$(function () {

    // handle slide images
    $('.testimonial-slide').each(function () {
        var self = $(this),
            img = $(self).find('img'),
            htmlContent = $(self).find('.HtmlContent');

        $(img).insertBefore(htmlContent);
        $(img).wrap('<div class="img-container" />');

        $(self).find('p:empty').remove();
    });

    // create carousel
    $('.testimonial-slider > .col-md-12').slick({
        dots: true,
        arrows: true,
        infinite: true,
        fade: true,
        autoplay: false,
        prevArrow: '<button type="button" class="slick-arrow prev-arrow"><span class="sr-only">Back</span><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-arrow next-arrow"><span class="sr-only">Next</span><i class="fa-solid fa-chevron-right"></i></button>'
    });

$('.testimonial-slide .img-container img').each(function () {
    const img = this;
    $(img).on('load', function () {
        const w = img.naturalWidth;
        const h = img.naturalHeight;

        if (w > h) {
            $(img).addClass('wide-img');
        } else if (h > w) {
            $(img).addClass('tall-img');
        }
    });
    // Handle cached images that may not fire load again
    if (img.complete) {
        $(img).trigger('load');
    }
});

});